/* eslint-disable react/jsx-closing-tag-location */
/* eslint-disable react/jsx-closing-bracket-location */
import { makeStyles } from '@material-ui/core';
import FormControl from '@material-ui/core/FormControl';
import FormHelperText from '@material-ui/core/FormHelperText';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import React from 'react';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles({
	select: {
		'& ul': {
			display: 'grid',
			columnGap: '20px',
			gridTemplateColumns: '1fr 1fr'
		}
	}
});

export default function (props) {
	const { t } = useTranslation();
	const classes = useStyles();

	return (
		<FormControl variant="outlined">
			<InputLabel id="demo-simple-select-outlined-label" ref={props.inputLabel}>
				{props.label}
			</InputLabel>
			<Select
				MenuProps={{ classes: { paper: classes.select } }}
				disabled={props.isDisabled}
				error={props.error}
				fullWidth
				id="demo-simple-select-outlined"
				labelId="demo-simple-select-outlined-label"
				labelWidth={props.labelWidth}
				onChange={props.onChange}
				value={props.value || ''}>
				{props.options.length > 0 &&
					props.options.map((option, index) => (
						<MenuItem key={index} value={option?.value}>
							{(() => {
								return props.translate ? t(`label.${option?.label}`) : option.label;
							})()}
						</MenuItem>
					))}
			</Select>

			<FormHelperText id="text-red">{props.error}</FormHelperText>
		</FormControl>
	);
}
